import CasesReportPage from '@/views/cases/report'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/cases/report')({
  component: CasesReportPage,
})
